// Operation — BarChart visites par mois (payées vs non payées) + sélecteur d'année.
import { useMemo, useState } from "react";
import { BarChart3, Loader2 } from "lucide-react";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from "recharts";
import { YearSelector } from "../../components/ui/year-selector";
import { useOperationFetch } from "./useOperationFetch";

const Tip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg px-3 py-2 text-xs shadow-xl border"
      style={{ background: "var(--oh-bg-elevated)", borderColor: "var(--oh-border)", color: "var(--oh-text)" }}>
      <p className="font-semibold mb-1">{label}</p>
      {payload.map((e, i) => <p key={i} style={{ color: e.color }}>{e.name}: <b>{e.value}</b></p>)}
    </div>
  );
};

export default function OperationEvolutionWidget() {
  const { data, loading } = useOperationFetch();
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());

  const years = useMemo(() => {
    if (!data?.evolution_mensuelle) return [new Date().getFullYear().toString()];
    return [...new Set(data.evolution_mensuelle.map(m => m.mois.slice(0, 4)))].sort();
  }, [data]);

  const chart = useMemo(() => {
    if (!data?.evolution_mensuelle) return [];
    return data.evolution_mensuelle
      .filter(m => m.mois.startsWith(selectedYear))
      .map(m => ({ ...m, label: new Date(m.mois + "-01").toLocaleDateString("fr-FR", { month: "short", year: "2-digit" }) }));
  }, [data, selectedYear]);

  if (loading) return <div className="rounded-xl p-5 flex items-center justify-center"
    style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}>
    <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--oh-text-muted)" }} /></div>;

  return (
    <div className="rounded-xl p-5" style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      data-testid="operation-evolution-widget">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold flex items-center gap-2" style={{ color: "var(--oh-text)" }}>
          <BarChart3 className="w-4 h-4" style={{ color: "var(--oh-stat-orange-text)" }} />
          Visites par mois
        </h3>
        <YearSelector selectedYear={selectedYear} onYearChange={setSelectedYear} availableYears={years} accentColor="var(--oh-stat-orange-text)" />
      </div>
      {chart.length ? (
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={chart}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--oh-border)" />
            <XAxis dataKey="label" tick={{ fill: "var(--oh-text-muted)", fontSize: 11 }} />
            <YAxis tick={{ fill: "var(--oh-text-muted)", fontSize: 11 }} />
            <Tooltip content={<Tip />} />
            <Bar dataKey="payees" name="Payées" stackId="a" fill="#10b981" />
            <Bar dataKey="non_payees" name="Non payées" stackId="a" fill="var(--oh-stat-amber-text)" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      ) : <div className="flex items-center justify-center h-48" style={{ color: "var(--oh-text-muted)" }}>Pas de données</div>}
    </div>
  );
}
